export var TypeActionInventoryInfo;
(function (TypeActionInventoryInfo) {
    TypeActionInventoryInfo["Received"] = "InventoryInfo > Received";
    TypeActionInventoryInfo["AddResource"] = "InventoryInfo > AddResource";
    TypeActionInventoryInfo["RemoveResource"] = "InventoryInfo > RemoveResource";
    TypeActionInventoryInfo["UpdateResource"] = "InventoryInfo > UpdateResource";
    TypeActionInventoryInfo["AddBuilding"] = "InventoryInfo > AddBuilding";
    TypeActionInventoryInfo["RemoveBuilding"] = "InventoryInfo > RemoveBuilding";
    TypeActionInventoryInfo["UpdateBuilding"] = "InventoryInfo > UpdateBuilding";
    TypeActionInventoryInfo["AddPackage"] = "InventoryInfo > AddPackage";
    TypeActionInventoryInfo["RemovePackage"] = "InventoryInfo > RemovePackage";
    TypeActionInventoryInfo["UpdatePackage"] = "InventoryInfo > UpdatePackage";
    TypeActionInventoryInfo["AddProfilePicture"] = "InventoryInfo > AddProfilePicture";
    TypeActionInventoryInfo["RemoveProfilePicture"] = "InventoryInfo > RemoveProfilePicture";
    TypeActionInventoryInfo["UpdateProfilePicture"] = "InventoryInfo > UpdateProfilePicture";
    TypeActionInventoryInfo["RequestAddResource"] = "InventoryInfo > RequestAddResource";
})(TypeActionInventoryInfo || (TypeActionInventoryInfo = {}));
export var actionInventoryInfoReceived = function (props) { return ({
    inventoryInfo: props,
    type: TypeActionInventoryInfo.Received,
}); };
export var actionInventoryInfoAddResource = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.AddResource,
}); };
export var actionInventoryInfoRemoveResource = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.RemoveResource,
}); };
export var actionInventoryInfoUpdateResource = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.UpdateResource,
}); };
export var actionInventoryInfoUpdateBuilding = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.UpdateBuilding,
}); };
export var actionInventoryInfoUpdatePackage = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.UpdatePackage,
}); };
export var actionInventoryInfoAddBuilding = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.AddBuilding,
}); };
export var actionInventoryInfoRemoveBuilding = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.RemoveBuilding,
}); };
export var actionInventoryInfoUpdateProfilePicture = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.AddProfilePicture,
}); };
export var actionInventoryInfoAddProfilePicture = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.AddProfilePicture,
}); };
export var actionInventoryInfoRemoveProfilePicture = function (items) { return ({
    items: items,
    type: TypeActionInventoryInfo.AddProfilePicture,
}); };
export var actionInventoryInfoRequestAddResource = function (resourceId) { return ({
    resourceId: resourceId,
    type: TypeActionInventoryInfo.RequestAddResource,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/actionInventoryInfo.ts
// module id = 29
// module chunks = 3